import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { apiFetch, waHref } from "../lib/api";

export default function StudioClients() {
  const [clients, setClients] = useState(null);
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    apiFetch("/admin/studio/clients").then(setClients);
  }, []);

  const rows = clients ? (filter === "all" ? clients : clients.filter((c) => c.stage === filter)) : [];
  const stages = ["Enquiry", "Qualified", "Quoted", "Accepted", "Deposit Paid", "Onboarding", "In Progress", "Client Review", "Balance Paid", "Launched", "Completed"];

  return (
    <div data-testid="studio-clients-page">
      <p className="text-[10px] font-semibold uppercase tracking-[0.25em] text-ink/50">IAGSB Digital Studio</p>
      <h1 className="mt-2 font-serif text-3xl text-ink">Clients</h1>

      <div className="mt-6 flex flex-wrap gap-2" data-testid="studio-stage-filters">
        {["all", ...stages].map((s) => (
          <button key={s} onClick={() => setFilter(s)} data-testid={`stage-filter-${s.toLowerCase().replace(/\s+/g, "-")}`} className={`px-3 py-1.5 text-[10px] font-semibold uppercase tracking-[0.12em] ${filter === s ? "bg-ink text-warmwhite" : "border border-ink/15 text-ink/60 hover:text-ink"}`}>
            {s}
          </button>
        ))}
      </div>

      <div className="mt-4 overflow-x-auto border border-ink/10 bg-warmwhite" data-testid="studio-clients-table">
        <table className="w-full min-w-[760px] text-left text-sm">
          <thead>
            <tr className="border-b border-ink/10 text-[9px] font-bold uppercase tracking-[0.2em] text-ink/50">
              <th className="px-4 py-3">Ref</th><th className="px-4 py-3">Business</th><th className="px-4 py-3">Contact</th>
              <th className="px-4 py-3">Stage</th><th className="px-4 py-3">Outstanding</th><th className="px-4 py-3">Next action</th>
            </tr>
          </thead>
          <tbody>
            {!clients ? (
              <tr><td colSpan="6" className="px-4 py-8 text-center text-ink/40">Loading…</td></tr>
            ) : rows.length === 0 ? (
              <tr><td colSpan="6" className="px-4 py-8 text-center text-ink/40">No clients at this stage.</td></tr>
            ) : rows.map((c) => (
              <tr key={c.id} className="border-b border-ink/5 last:border-0" data-testid={`studio-client-row-${c.id}`}>
                <td className="px-4 py-3 text-xs text-ink/50">{c.ref}</td>
                <td className="px-4 py-3">
                  <Link to={`/admin/studio/clients/${c.id}`} className="font-medium text-ink underline decoration-amber decoration-2 underline-offset-4" data-testid={`studio-client-link-${c.id}`}>{c.business_name}</Link>
                  {c.is_test && <span className="ml-2 rounded-full border border-ink/20 bg-ink/5 px-2 py-0.5 text-[9px] font-bold uppercase tracking-[0.12em] text-ink/50" data-testid={`studio-client-test-badge-${c.id}`}>Test — excluded from reports</span>}
                </td>
                <td className="px-4 py-3 text-xs text-ink/70">
                  {c.contact_name}<br />
                  <a href={waHref(c.phone, `Hi ${c.contact_name}, this is Irma from IAGSB Digital Studio regarding ${c.ref}.`)} target="_blank" rel="noreferrer" className="font-semibold text-[#1faa55]" data-testid={`studio-wa-${c.id}`}>WhatsApp {c.phone}</a>
                </td>
                <td className="px-4 py-3"><span className="rounded-full border border-amber/40 bg-amber/10 px-2 py-0.5 text-[9px] font-bold uppercase tracking-[0.12em] text-amber">{c.stage}</span></td>
                <td className="px-4 py-3 text-sm">{c.outstanding > 0 ? <span className="font-semibold text-burgundy">RM{Number(c.outstanding).toLocaleString()}</span> : <span className="text-ink/40">—</span>}</td>
                <td className="px-4 py-3 text-xs text-ink/60">{c.next_action || "—"}{c.next_action_date ? ` · ${c.next_action_date}` : ""}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
